<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'StackedColumnPie',
  props: {
    title: {
      type: String,
      default: ''
    },
    legend: {
      type: Array,
      default: () => []
    },
    color: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    deep: true,
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      let xData = []
      let yData1 = []
      let yData2 = []
      // let legendData = ['设备数量', '分数段占比']
      let showEchart = false
      let namenum = 0
      if (this.data) {
        xData = this.data.map((el) => {
          return el.time
        })
        // let datas = Object.values(this.data)
        yData1 = this.data.map((itm) => {
          return itm.count
        })
        yData2 = this.data.map((itm) => {
          return itm.pcl
        })
      }
      if (xData) {
        if (xData.length > 0) {
          namenum = Math.floor(100 / (xData.length / 5))
          if (xData.length > 5) {
            showEchart = true
          } else {
            showEchart = false
          }
        }
      }
      // }
      let option = {
        title: {
          text: this.title,
          top: 15,
          x: '4%',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          },
          subtextStyle: {
            color: '#90979c',
            fontSize: '14'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            textStyle: {
              color: '#000'
            }
          }
        },
        grid: {
          borderWidth: 0,
          top: 90,
          left: '4%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
          textStyle: {
            color: '#000'
          }
        },
        legend: {
          x: '40%',
          top: '10%',
          textStyle: {
            color: '#90979c'
          },
          data: this.legendData
        },

        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 10
              formatter: function (params) {
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 7 //一行显示几个字
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
            },

            data: xData
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          }
        ],
        // color: ['#5470C6', 'orange'],
        color: this.color,
        yAxis: [
          // {
          //   type: 'value',
          //   min: (value) => {
          //     return value.min
          //   },
          //   max: (value) => {
          //     return value.max
          //   },
          //   splitLine: {
          //     show: true
          //   }
          // },
          {
            type: 'value',
            name: this.legend[0],
            minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数
            // min: (value) => {
            //   if (value.min > 0 || value.min == 0) {
            //     return value.min - 1
            //   } else {
            //     return value.min
            //   }
            // },
            // max: (value) => {
            //   return value.max
            // },
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 100) * 100
            },
            max: (value) => {
              return Math.ceil(value.max)
              // return Math.ceil(value.max / 100) * 100
            },
            // interval: 500,
            axisLabel: {
              color: this.color[0]
              // formatter: '{value} %'
            }
          },
          {
            type: 'value',
            name: this.legend[1],
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 10) * 10
            },
            max: (value) => {
              return Math.ceil(value.max)
              // return Math.ceil(value.max / 100) * 100
            },
            // interval: 5,
            axisLabel: {
              color: this.color[1],
              formatter: '{value} %'
            }
          }
        ],

        dataZoom: [
          {
            type: 'slider',
            realtime: true,
            start: 0,
            end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
            height: 5, //组件高度
            left: 5, //左边的距离
            right: 5, //右边的距离
            bottom: 10, //下边的距离
            show: showEchart, // 是否展示
            fillerColor: 'rgba(17, 100, 210, 0.42)', // 滚动条颜色
            borderColor: 'rgba(17, 100, 210, 0.12)',
            handleSize: 0, //两边手柄尺寸
            showDetail: false, //拖拽时是否展示滚动条两侧的文字
            zoomLock: true, //是否只平移不缩放
            moveOnMouseMove: false, //鼠标移动能触发数据窗口平移
            //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放

            //下面是自己发现的一个问题，当点击滚动条横向拖拽拉长滚动条时，会出现文字重叠，导致效果很不好，以此用下面四个属性进行设置，当拖拽时，始终保持显示六个柱状图，可结合自己情况进行设置。添加这个属性前后的对比见**图二**
            startValue: 0, // 从头开始。
            endValue: 6, // 最多六个
            minValueSpan: 6, // 放大到最少几个
            maxValueSpan: 6 //  缩小到最多几个
          },
          {
            type: 'inside', // 支持内部鼠标滚动平移
            start: 0,
            end: namenum,
            zoomOnMouseWheel: false, // 关闭滚轮缩放
            moveOnMouseWheel: true, // 开启滚轮平移
            moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
          }
        ],
        // series: yData
        series: [
          {
            name: this.legend[0],
            type: 'bar',
            barMaxWidth: '40%',
            tooltip: {
              valueFormatter: function (value) {
                return value
              }
            },
            itemStyle: {
              normal: {
                // color: function (params) {
                //   console.log(params, '9999999999999')
                //   var colorlist = [
                //     '#5bc2e7',
                //     '#6980c5',
                //     '#70dfdf',
                //     '#3390FF',
                //     '#9192ab',
                //     '#7898e1',
                //     '#efa666',
                //     '#eddd86',
                //     '#9987ce',
                //     '#63b2ee',
                //     '#76da91'
                //   ]
                //   return colorlist[params.dataIndex]
                // },

                label: {
                  show: true,
                  fontSize: 14,
                  color: this.color[0],

                  position: 'top',
                  formatter: '{c}'
                }
              }
            },
            data: yData1
            //   [
            //   2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4,
            //   3.3
            // ]
          },

          {
            name: this.legend[1],
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %'
              }
            },
            data: yData2,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  color: this.color[1],
                  position: 'right'
                  // formatter: '{c}%'
                }
              }
            }
          }
        ]
      }

      mychart.setOption(option, true)
    }
  }
}
</script>
